import React, { useState } from 'react'
import { Alert, Box } from '@mui/material'
import { useIdentity } from 'pages/Identity/Login'

const PendingReviewBanner = () => {
  const { registrationStatus } = useIdentity()
  const [dismissed, setDismissed] = useState(false)

  if (registrationStatus !== 'Pending' || dismissed) {
    return null
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Alert
        severity='warning'
        onClose={() => setDismissed(true)}
      >
        Your organization is being verified. You'll receive an email once your account is approved.
      </Alert>
    </Box>
  )
}

export default PendingReviewBanner
